<template>
    <div
        :class="{ 'translate-x-[1024px]': !isOpen }"
        class="z-50 fixed inset-0 w-full h-full flex flex-col bg-white transform transition-all duration-500 ease-in-out"
    >
        <header class="sticky p-5 flex justify-between items-center">
            <button
                @click="emitClose"
                type="button"
                aria-label="close modal"
                class="w-5 h-5"
            >
                <img
                    src="../assets/images/icons/arrow-back.svg"
                    width="20"
                    height="20"
                    alt="Back arrow"
                >
            </button>

            <slot name="header" />
        </header>

        <div
            ref="optionsList"
            class="flex-1 overflow-y-auto"
        >
            <div class="p-5 pt-0">
                <slot name="content" />
            </div>

            <slot name="footer" />
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            isOpen: {
                type: Boolean,
                required: true,
            },
        },

        watch: {
            isOpen() {
                if (this.isOpen) {
                    this.scrollToTop();
                }
            },
        },

        methods: {
            scrollToTop() {
                this.$refs.optionsList.scrollTo(0, 0);
            },

            emitClose() {
                this.$emit('overlayClose');
            },
        },
    };
</script>
